<div class="d-flex flex-column ws-flex-auto min-height-0">
    <ws-bread-crumbs [breadcrumbs]="breadcrumbs" currentPageTitle="Client Services"></ws-bread-crumbs>
    <div class="ws-section">
        <div class="ws-section__header">
            <h4 class="ws-section__header__title page-title">Client Services</h4>
            <div class="ws-section__header__actions">
                @if (isLongRunningProcessRunning) {
                    <div class="ws-section__header__actions__item">
                        <i class="fa fa-info-circle pe-2"></i>Update in progress
                    </div>
                }
                @if (canLaunchHistory) {
                    <div class="ws-section__header__actions__item">
                        <button
                            class="ace-btn btn-sm btn-secondary has-icon"
                            (click)="launchHistoryModal()"
                            data-qa="client-services-history"
                        >
                            <i class="fa fa-history"></i>
                        </button>
                    </div>
                }
                @if (canEdit) {
                    <div class="ws-section__header__actions__item">
                        <button
                            class="ace-btn btn-sm btn-primary has-icon"
                            (click)="goToEditMode()"
                            [disabled]="enteringEditMode"
                            data-qa="client-services-edit"
                        >
                            <i class="fa fa-pencil"></i>
                        </button>
                    </div>
                }
                @if (canSave) {
                    @if (isExplicitView) {
                        <div class="ws-section__header__actions__item">
                            <button
                                class="ace-btn btn-sm btn-secondary has-icon"
                                (click)="launchHistoryModal()"
                                [disabled]="serverAction"
                                data-qa="client-services-history"
                            >
                                <i class="fa fa-history"></i>
                            </button>
                        </div>
                    }
                    <div class="ws-section__header__actions__item">
                        @if (!isLongRunningProcessRunning) {
                            <button
                                class="ace-btn btn-sm btn-primary has-icon btn-success"
                                (click)="savePanel()"
                                [disabled]="serverAction"
                                data-qa="client-services-save"
                            >
                                <i class="fa fa-save"></i>
                            </button>
                        }
                        <button
                            class="ace-btn btn-sm btn-primary has-icon btn-danger"
                            (click)="cancelEdit()"
                            data-qa="client-services-cancel"
                        >
                            <i class="fa fa-close"></i>
                        </button>
                    </div>
                }
            </div>
        </div>
    </div>
    <div class="ws-section flex-grow-1 bg-white py-3 px-2 ace-radius position-relative min-height-0">
        @if (panelLoading || !panelData || !entity) {
            <ws-ace-loader [hideLabel]="false" [label]="serverAction ? 'Saving Panel' : null"></ws-ace-loader>
        } @else {
            <div>
                <div class="d-flex justify-content-between">
                    <div class="d-flex align-items-center" style="gap: 10px">
                        <strong>Account Handler:</strong>
                        @if (!editMode || !isCompany || !isExplicitView) {
                            <div [ngClass]="{ overridden: isAccountHandlerOverridden }">
                                {{ accountHandlerTitle }}
                            </div>
                        }
                        @if (editMode && isCompany && isExplicitView) {
                            <user-team-picker
                                style="width: 500px"
                                [entityTypeScope]="entity.type"
                                [entityIdScope]="entity.id"
                                [userId]="panelData.accountHandlerUserID"
                                [teamId]="panelData.accountHandlerTeamID"
                                [parentUsers]="ahAvailableUsers"
                                [fallbackDisplayName]="accountHandlerTitle"
                                (userChange)="accountHandlerSelected($event)"
                                data-qa="client-services-account-handler-picker"
                            >
                            </user-team-picker>
                        }
                        @if (!isExplicitView && editMode) {
                            <span>
                                <i
                                    class="fa fa-info-circle"
                                    title="Changes to Consultant's Account Handler are made from the Manage Consulting Engagements menu"
                                >
                                </i>
                            </span>
                        }
                    </div>
                    @if (!editMode && entity.canEditCompanySetups) {
                        <a
                            anchor-route
                            [sref]="{
                                target: 'csrCommandCenterEntity',
                                options: { entityId: entity.id, entityTypeId: entity.typeId },
                            }"
                            [isTargetBlank]="true"
                            class="me-2"
                            tabindex="0"
                            data-qa="client-services-command-center"
                        >
                            Command Center
                        </a>
                    }
                </div>

                @if(isEntityInRyanInstance) {
                <div class="d-flex justify-content-between">
                    <div class="d-flex align-items-center" style="gap: 10px">
                        <strong>AH Engagement Code:</strong>
                        <div [ngClass]="{ overridden: panelData.accountHandlerEngagementOverriden }">
                            {{ accountHandlerEngagement }}
                        </div>

                        @if (canEditOtherClientServices && isCompany ) {
                            @if (isTopLevelCompany) {
                                <button class="btn btn-sm btn-link p-0"
                                        (click)="lookupEngagement()"
                                        tooltip="Select Engagement Number"
                                        style="line-height: 1"
                                        >
                                    <i class="fa fa-binoculars"></i>
                                </button>

                                @if (panelData.accountHandlerEngagementOverriden) {
                                    <button
                                        class="btn btn-sm btn-link p-0"
                                        type="button"
                                        title="Reset to default engagement code (latest Appeals Real Estate contract term at the Top-Level Company)"
                                        (click)="resetAhCode()"
                                        style="line-height: 1; color: red;"
                                    >
                                        <i class="fa fa-arrow-rotate-left"></i>
                                    </button>
                                }
                            }
                        }

                        <span class="ms-5">
                            @if (panelData.engagementContacts?.length) {
                                @for (contact of engagementContacts; track contact; let isLast = $last) {
                                    <span [style.margin-right]="isLast ? '0' : '25px'">
                                        <strong>{{ contact.abbr }}:</strong> {{ contact.name }}
                                    </span>
                                }
                            }
                        </span>

                    </div>
                </div>
                }

                <div class="row mt-2">
                    <div class="col-lg-5">
                        <h4>Responsibilities:</h4>
                    </div>
                    <div class="col-lg-7">
                        <h4>Delivery Details:</h4>
                    </div>
                </div>
                @for (service of panelData.entityClientServices; track service) {
                    <div class="card panel-flat-color secondary-panel small-panel mb-0">
                        <div class="panel-flat-header small-header">
                            <h3>{{ service.name }}</h3>
                        </div>
                        <div class="card-body px-3">
                            <div class="row d-flex">
                                <div class="col-lg-5 py-3 text-nowrap" style="border-right: 2px solid #c1c9c9">
                                    <!--responsibilities list -->
                                    @for (
                                        responsibility of service.responsibilities;
                                        track responsibility;
                                        let i = $index
                                    ) {
                                        <div class="d-flex align-items-center justify-content-between mb-2">
                                            <div class="d-flex align-items-center flex-wrap" style="column-gap: 15px">
                                                <!-- property type abbreviation colored square-->
                                                <div
                                                    class="label property-type-{{ responsibility.propTypeAbbr }}"
                                                    style="font-size: 110%; min-width: 40px"
                                                >
                                                    {{ responsibility.propTypeAbbr }}
                                                </div>
                                                @if (!canEditResponsibility(responsibility)) {
                                                    <div [ngClass]="{ overridden: responsibility.isException }">
                                                        {{
                                                            responsibility.placeholderText
                                                                ? responsibility.placeholderText
                                                                : responsibility.assigneeDisplay
                                                        }}
                                                    </div>
                                                }
                                                @if (
                                                    showResponsibilityUpdatingInfoIcon(
                                                        responsibility.clientServiceResponsibilityUpdateStatus
                                                    )
                                                ) {
                                                    <div
                                                        title="This responsibility is updating in the background.  Changes can't be made until they are finished"
                                                    >
                                                        <i class="fa fa-info-circle"></i>
                                                    </div>
                                                }
                                                @if (
                                                    canEditResponsibility(responsibility) &&
                                                    responsibility.disabledWorkflowUserTypes
                                                ) {
                                                    <select
                                                        class="form-select form-select-sm w-auto"
                                                        [ngModel]="responsibility.translatedWorkflowUserTypeId"
                                                        (ngModelChange)="userTypeChanged($event, responsibility)"
                                                        [attr.data-qa]="
                                                            'client-services-responsibility-workflow-user-type-' + i
                                                        "
                                                    >
                                                        @for (type of workflowUserTypes; track type; let j = $index) {
                                                            @if (showWorkflowUserTypeOption(type.value)) {
                                                                <option
                                                                    [ngValue]="type.value"
                                                                    [disabled]="
                                                                        responsibility.disabledWorkflowUserTypes.includes(
                                                                            type.value
                                                                        )
                                                                    "
                                                                    [attr.data-qa]="
                                                                        'client-services-responsibility-workflow-user-type-option-' +
                                                                        i +
                                                                        '-' +
                                                                        j
                                                                    "
                                                                >
                                                                    {{ type.name }}
                                                                </option>
                                                            }
                                                        }
                                                    </select>
                                                }
                                                <div class="d-flex flex-wrap">
                                                    @if (showSpecificIndividualUserTeamPicker(responsibility)) {
                                                        <user-team-picker
                                                            class="mt-1"
                                                            style="min-width: 300px"
                                                            [entityTypeScope]="entity.type"
                                                            [instanceIdScope]="currentInstanceId"
                                                            [entityIdScope]="entity.id"
                                                            [userId]="responsibility.userID"
                                                            [teamId]="responsibility.teamID"
                                                            [revertIfEmptyOnBlur]="true"
                                                            [parentUsers]="csrAvailableUsers"
                                                            [placeholder]="responsibility.placeholderText"
                                                            (userChange)="
                                                                specificIndividualSelected($event, responsibility)
                                                            "
                                                            [attr.data-qa]="
                                                                'client-services-responsibility-user-picker-' + i
                                                            "
                                                        >
                                                        </user-team-picker>
                                                    }
                                                    <!--calendar-->
                                                    @if (
                                                        canEditResponsibility(responsibility) &&
                                                        responsibility.showDatePicker
                                                    ) {
                                                        <div
                                                            class="d-flex align-items-center mt-1 ms-2"
                                                            style="gap: 5px"
                                                        >
                                                            <label for="dateFrom">From Date:</label>
                                                            <weissman-datetime
                                                                [(inputDate)]="responsibility.dateFrom"
                                                                [dateOnly]="true"
                                                                [attr.data-qa]="
                                                                    'client-services-responsibility-from-date-' + i
                                                                "
                                                            >
                                                            </weissman-datetime>
                                                        </div>
                                                    }
                                                </div>
                                                <!-- consulting engagements -->
                                                @if (showConsultingEngagementsList(responsibility)) {
                                                    <div>
                                                        @if (consultingEngagements.length === 1) {
                                                            <div> - {{ consultingEngagements[0].name }}</div>
                                                        }
                                                        @if (consultingEngagements.length > 1) {
                                                            <select
                                                                class="form-select form-select-sm w-auto"
                                                                [(ngModel)]="responsibility.consultingEngagementId"
                                                                (change)="changeConsultingEngagement(responsibility)"
                                                                [attr.data-qa]="
                                                                    'client-services-responsibility-engagement-' + i
                                                                "
                                                            >
                                                                @for (
                                                                    consultingEngagement of consultingEngagements;
                                                                    track consultingEngagement;
                                                                    let j = $index
                                                                ) {
                                                                    <option
                                                                        [ngValue]="
                                                                            consultingEngagement.consultingEngagementId
                                                                        "
                                                                        [attr.data-qa]="
                                                                            'client-services-responsibility-engagement-option-' +
                                                                            i +
                                                                            '-' +
                                                                            j
                                                                        "
                                                                    >
                                                                        {{ consultingEngagement.name }}
                                                                    </option>
                                                                }
                                                            </select>
                                                        }
                                                    </div>
                                                }
                                                @if (
                                                    showRetryResponsibilityUpdateIcon(
                                                        responsibility.clientServiceResponsibilityUpdateStatus
                                                    )
                                                ) {
                                                    <button
                                                        class="ace-btn has-icon"
                                                        style="top: 5px"
                                                        (click)="retryResponsibilityUpdate(responsibility)"
                                                        title="This responsibility didn't update correctly.  Push this button to retry the updates.  Some changes can't be made until the updates succeed."
                                                        [attr.data-qa]="'client-services-responsibility-retry-' + i"
                                                    >
                                                        <i class="fa fa-repeat"></i>
                                                    </button>
                                                }
                                            </div>
                                            <!--Exceptions link-->
                                            @if (
                                                showExceptionsLink(
                                                    responsibility.clientServiceResponsibilityUpdateStatus
                                                )
                                            ) {
                                                <div>
                                                    @if (responsibility.customerHasChildExceptions) {
                                                        <span
                                                            class="anchor-style"
                                                            role="button"
                                                            tabindex="0"
                                                            (click)="openExceptionsModal(responsibility, service)"
                                                            (keyup.enter)="openExceptionsModal(responsibility, service)"
                                                            [attr.data-qa]="
                                                                'client-services-responsibility-exceptions-' + i
                                                            "
                                                        >
                                                            Exceptions
                                                        </span>
                                                    }
                                                </div>
                                            }
                                        </div>
                                    }
                                </div>
                                <div class="col-lg-7 py-3">
                                    @if (
                                        service.clientServiceID === ClientServiceType.ComplianceReturns &&
                                        hasComplianceFeatureView &&
                                        entity.isTopLevel
                                    ) {
                                        <delivery-details-compliance-returns
                                            [editMode]="canEditOtherClientServices && isCompany && !isLicensedDIUser"
                                            [entity]="entity"
                                            [(currentData)]="service.deliveryDetailPPReturnBatchCurrent"
                                            [service]="service"
                                            [ces]="consultingEngagements"
                                            [entityInstanceId]="entityInstanceId"
                                            [isConsultantPerspective]="isConsultantPerspective"
                                            [userSearchInstanceId]="currentInstanceId"
                                        >
                                        </delivery-details-compliance-returns>
                                    }
                                    @if (
                                        service.clientServiceID === ClientServiceType.ComplianceReturns &&
                                        hasComplianceFeatureView &&
                                        !entity.isTopLevel
                                    ) {
                                        <delivery-details-compliance-returns
                                            [editMode]="canEditOtherClientServices && isCompany && !isConsultantPerspective"
                                            [entity]="entity"
                                            [(currentData)]="service.deliveryDetailPPReturnBatchTop"
                                            [service]="service"
                                            [ces]="consultingEngagements"
                                            [entityInstanceId]="entityInstanceId"
                                            [isConsultantPerspective]="isConsultantPerspective"
                                            [userSearchInstanceId]="currentInstanceId"
                                        >
                                        </delivery-details-compliance-returns>
                                    }
                                    @if (service.clientServiceID === ClientServiceType.Assessments) {
                                        <delivery-details-team-retrieves
                                            [editMode]="canEditOtherClientServices && (!isConsultantPerspective || isLicensedDIUser)"
                                            [(currentData)]="service.deliveryDetailAssessmentCurrent"
                                            [topLevelData]="service.deliveryDetailAssessmentTop"
                                            [entity]="entity"
                                            [(taxFeedIsEnabled)]="taxFeedSettings.assessmentsTaxFeedsEnabled"
                                            [taxFeedEnablingMessage]="
                                                isParcel
                                                    ? 'Parcel assessments will be updated via PTX tax feed.'
                                                    : 'All company parcel assessments will be updated via PTX tax feed.'
                                            "
                                            [taxFeedDisablingMessage]="
                                                isParcel
                                                    ? 'Parcel assessments will not be updated via PTX tax feed.'
                                                    : 'All company parcel assessments will not be updated via PTX tax feed.'
                                            "
                                            [taxFeedToggleEnabled]="
                                                isTaxFeedToggleEnabled(
                                                    topLevelCompanyTaxFeedSettings?.assessmentsTaxFeedsEnabled
                                                )
                                            "
                                            [taxFeedToggleVisible]="isTopLevelCompany || isParcel"
                                            [isEntityInRyanInstance]="isEntityInRyanInstance || isLicensedDIUser"
                                        >
                                        </delivery-details-team-retrieves>
                                    }
                                    @if (service.clientServiceID === ClientServiceType.TaxBills) {
                                        <delivery-details-team-retrieves
                                            [editMode]="canEditOtherClientServices && (!isConsultantPerspective || isLicensedDIUser)"
                                            [(currentData)]="service.deliveryDetailBillCurrent"
                                            [topLevelData]="service.deliveryDetailBillTop"
                                            [entity]="entity"
                                            [(taxFeedIsEnabled)]="taxFeedSettings.taxBillsTaxFeedsEnabled"
                                            [taxFeedEnablingMessage]="
                                                isParcel
                                                    ? 'Parcel tax bills will be updated via PTX tax feed.'
                                                    : 'All company parcel tax bills will be updated via PTX tax feed.'
                                            "
                                            [taxFeedDisablingMessage]="
                                                isParcel
                                                    ? 'Parcel tax bills will not be updated via PTX tax feed.'
                                                    : 'All company parcel tax bills will not be updated via PTX tax feed.'
                                            "
                                            [taxFeedToggleEnabled]="
                                                isTaxFeedToggleEnabled(
                                                    topLevelCompanyTaxFeedSettings?.taxBillsTaxFeedsEnabled
                                                )
                                            "
                                            [taxFeedToggleVisible]="isTopLevelCompany || isParcel"
                                            [isEntityInRyanInstance]="isEntityInRyanInstance || isLicensedDIUser"
                                        >
                                        </delivery-details-team-retrieves>
                                    }
                                    @if (service.clientServiceID === ClientServiceType.TaxBillTransmit) {
                                        <delivery-details-transmit
                                            [currentData]="service.taxBillDeliveryDetailsCurrent"
                                            [topLevelData]="service.taxBillDeliveryDetailsTop"
                                            [editMode]="canEditOtherClientServices && !isConsultantPerspective && !isLicensedDIUser"
                                            [userSearchInstanceId]="currentInstanceId"
                                            [isEntityInRyanInstance]="isEntityInRyanInstance"
                                            (currentPaymentBatchDataChange)="paymentBatchData = $event"
                                            [entity]="entity"
                                        >
                                        </delivery-details-transmit>
                                    }
                                    @if (service.clientServiceID === ClientServiceType.Allocation) {
                                        <delivery-details-assessment-allocation
                                            [(currentData)]="service.deliveryDetailAssessmentAllocationTop"
                                            [editMode]="canEditOtherClientServices && !isConsultantPerspective"
                                            [entity]="entity"
                                            [ces]="consultingEngagements"
                                            [service]="service"
                                            [entityInstanceId]="entityInstanceId"
                                            [isConsultantPerspective]="isConsultantPerspective"
                                            [userSearchInstanceId]="currentInstanceId"
                                        >
                                        </delivery-details-assessment-allocation>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                }
                @if (isTopLevelCompany && canEditOtherClientServices && isExplicitView) {
                    <div class="d-flex mt-3" style="gap: 15px">
                        <ws-select
                            placeholder="Add Service"
                            [(ngModel)]="newClientService"
                            [isLoading]="loadingDropdownData"
                            (selectedOptionChanged)="addClientService()"
                            [options]="availableClientServices"
                            labelProperty="name"
                            [returnEntireOption]="true"
                            searchType="substring"
                            data-qa="client-services-add-service"
                        >
                        </ws-select>
                        <ws-select
                            placeholder="Add Property Type"
                            [(ngModel)]="newPropertyType"
                            [isLoading]="loadingDropdownData"
                            (selectedOptionChanged)="addPropertyType()"
                            [options]="availablePropertyTypes"
                            labelProperty="propTypeName"
                            [returnEntireOption]="true"
                            searchType="substring"
                            data-qa="client-services-add-property-type"
                        >
                        </ws-select>
                    </div>
                }
            </div>
        }
    </div>
</div>
